<template>
  <div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <form id="tabulator-html-filter-form" class="xl:flex sm:mr-auto">
          <div class="grid grid-cols-12 gap-x-2">
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Field</label>
                <select
                  id="tabulator-html-filter-field"
                  v-model="filter.field"
                  class="form-select"
                >
                  <option value="process_name">Process Name</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-3 xl:col-span-2 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Type</label>
                <select
                  id="tabulator-html-filter-type"
                  v-model="filter.type"
                  class="form-select w-fullo"
                >
                  <option value="like" selected>like</option>
                  <option value="=">=</option>
                  <option value="<">&lt;</option>
                  <option value="<=">&lt;=</option>
                  <option value=">">></option>
                  <option value=">=">>=</option>
                  <option value="!=">!=</option>
                </select>
              </div>
            </div>
            <div class="col-span-6 md:col-span-4 xl:col-span-3 my-1">
              <div class="flex items-center sm:mr-2">
                <label class="mr-2">Value</label>
                <input
                  id="tabulator-html-filter-value"
                  v-model="filter.value"
                  type="text"
                  class="form-control sm:w-40"
                  placeholder="Search..."
                />
              </div>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button
                id="tabulator-html-filter-go"
                type="button"
                class="btn btn-primary w-full"
                @click="onFilter"
              >
                Go
              </button>
            </div>
            <div class="col-span-3 md:col-span-2 xl:col-span-1 my-1">
              <button
                id="tabulator-html-filter-reset"
                type="button"
                class="btn btn-secondary w-full"
                @click="onResetFilter"
              >
                Reset
              </button>
            </div>
          </div>
        </form>
        <div class="flex mt-5 sm:mt-0">
          <div class="dropdown w-1/2 sm:w-auto">
            <button
              class="dropdown-toggle btn btn-outline-secondary w-full sm:w-auto"
              aria-expanded="false"
            >
              <FileTextIcon class="w-4 h-4 mr-2" /> Export
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button>
            <div class="dropdown-menu w-40">
              <div class="dropdown-menu__content box dark:bg-dark-1 p-2">
                <a
                  id="tabulator-export-csv"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportCsv"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export CSV
                </a>
                <a
                  id="tabulator-export-json"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportJson"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export JSON
                </a>
                <a
                  id="tabulator-export-xlsx"
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="onExportXlsx"
                >
                  <FileTextIcon class="w-4 h-4 mr-2" /> Export XLSX
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden">
        <div id="tabulator" ref="tableRef" class="mt-5"></div>
      </div>
    </div>

    <div id="new-order-modal" class="modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="font-medium text-base mr-auto">Process Mappings</h2>
          </div>
          <div class="modal-body grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
              <label for="pos-form-1" class="form-label">Process Name</label>
              <TomSelect
                v-model="formData.process_id"
                :options="{
                  placeholder: 'Select Process'
                }"
                disabled
                class="w-full"
              >
                <option :value="item.id" v-for="item in pagedata.all_process_items">{{ item.process_name }}</option>
              </TomSelect>
            </div>
            <div class="col-span-12">
              <label for="pos-form-1" class="form-label">Next Processes</label>
              <TomSelect
                v-model="formData.next_process"
                :options="{
                  placeholder: 'Select Process'
                }"
                multiple
                class="w-full"
              >
                <option :value="item.id" v-for="item in pagedata.process_items">{{ item.process_name }}</option>
              </TomSelect>
            </div>
          </div>
          <div class="modal-footer text-right">
            <button
              type="button"
              data-dismiss="modal"
              class="btn btn-outline-secondary w-32 mr-1"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary w-32"
              @click="submitForm"
            >
              Save Details
            </button>
            <!-- <button type="button" v-if="lengthForm.id != ''" class="btn btn-danger w-32 ml-1" @click="deleteItem">
              Delete
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
/* eslint-disable */
import { defineComponent, ref, onMounted, reactive, inject } from 'vue'
import xlsx from 'xlsx'
import feather from 'feather-icons'
import Tabulator from 'tabulator-tables'
import { useRouter } from 'vue-router'
import { BASE_URL } from '@/constants/config.js'

export default defineComponent({
  setup() {
    const router = useRouter()
    const tableRef = ref()
    const tabulator = ref()
    const filter = reactive({
      field: 'process_name',
      type: 'like',
      value: ''
    })

    const swal =  inject('$swal')
    const pagedata = reactive({
      process_items: [],
      all_process_items: []
    })

    const formData = reactive({
      process_id: "",
      next_process: []
    })

    const initTabulator = () => {
      tabulator.value = new Tabulator(tableRef.value, {
        ajaxURL: BASE_URL + 'api/master/get_process_details',
        ajaxConfig: {
          method: 'GET', //set request type to Position
          headers: {
            'Content-type': 'application/json; charset=utf-8', //set specific content type
            Authorization: 'Bearer ' + localStorage.getItem('token')
          }
        },
        ajaxFiltering: true,
        ajaxSorting: true,
        printAsHtml: true,
        printStyled: true,
        pagination: 'remote',
        paginationSize: 20,
        paginationSizeSelector: [10, 20, 30, 40],
        layout: 'fitColumns',
        headerSort: false,
        responsiveLayout: 'collapse',
        placeholder: 'No matching records found',
        columns: [
          // For HTML table
          {
            title: 'Proc Name',
            maxWidth: 300,
            field: 'process_name',
            vertAlign: 'middle',
            print: true,
            download: false,
            formatter(cell) {
              return `<div class="flex items-center">${cell.getData().process_name}
                ${
                  cell.getData().primary_phase == 1
                    ? `<div class="flex lg:justify-center text-white bg-primary-4 ml-2 rounded p-1 text-xs">
                     - Primary
                  </div>`
                    : ``
                }
              </div>

                  `
            }
          },

          {
            title: 'Next Processes',
            minWidth: 100,
            field: 'next_process',
            vertAlign: 'middle',
            print: true,
            download: false,
            format: 'textarea'
          },
          {
            title: 'Edit',
            width: 70,
            field: 'actions',
            responsive: 1,
            hozAlign: 'center',
            vertAlign: 'middle',
            print: false,
            download: false,
            formatter(cell) {
              const a = cash(`<div class="flex lg:justify-center items-center">
                <a class="flex items-center mr-3" href="javascript:;">
                  <i data-feather="check-square" class="w-4 h-4 mr-1"></i> Edit
                </a>

              </div>`)
              cash(a).on('click', function() {
                cash('#new-order-modal').modal('show')

                getProcesses(cell.getData().id, cell.getData())
              })

              return a[0]
            }
          }
        ],
        renderComplete() {
          feather.replace({
            'stroke-width': 1.5
          })
        }
      })
    }

    // Process List
    const getProcesses = async (id, item) => {

      console.log(item);

      formData.process_id = String(item.id)
      formData.next_process = item.next_processes
      const params = {
        excerpt_process: window.btoa(id)
      }

      let promise_url = 'api/master/dp_process'

      let promise = axios({
        url: promise_url,
        method: 'POST',
        data: params,
        baseURL: BASE_URL,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        },
        config: {
          headers: {
            Accept: 'application/json'
          }
        }
      })
      return promise
        .then(result => result.data)
        .then(data => {
          if (data.status === true) {
            pagedata.process_items = data.items
            pagedata.all_process_items = data.items
            pagedata.all_process_items.push(item)
          } else {
            pagedata.process_items = []
            pagedata.all_process_items = []
          }
        })
        .catch(_error => {
          console.error('Process list not found:', err)
          pagedata.process_items = [] // Optional: clear on error too
        })
    }

    // Redraw table onresize
    const reInitOnResizeWindow = () => {
      window.addEventListener('resize', () => {
        tabulator.value.redraw()
        feather.replace({
          'stroke-width': 1.5
        })
      })
    }

    // Filter function
    const onFilter = () => {
      tabulator.value.setFilter(filter.field, filter.type, filter.value)
    }

    // On reset filter
    const onResetFilter = () => {
      filter.field = 'first_name'
      filter.type = 'like'
      filter.value = ''
      onFilter()
    }

    // Export
    const onExportCsv = () => {
      tabulator.value.download('csv', 'data.csv')
    }

    const onExportJson = () => {
      tabulator.value.download('json', 'data.json')
    }

    const onExportXlsx = () => {
      const win = window
      win.XLSX = xlsx
      tabulator.value.download('xlsx', 'data.xlsx', {
        sheetName: 'Products'
      })
    }

    const onExportHtml = () => {
      tabulator.value.download('html', 'data.html', {
        style: true
      })
    }

    // Print
    const onPrint = () => {
      tabulator.value.print()
    }

    const submitForm = () => {
      const promise_url = "api/master/updateToDoProcess"; // since it's same in both conditions

      axios({
        url: promise_url,
        method: "POST",
        data: formData,
        baseURL: BASE_URL,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          Accept: "application/json"
        }
      })
        .then(response => {
          const data = response.data;

          // Close modal and refresh table
          cash('#new-order-modal').modal('hide');
          tabulator.value.setFilter(filter.field, filter.type, filter.value);

          // Reset form fields
          formData.process_id = "";
          formData.next_process = [];
        })
        .catch(error => {
          swal({
            text: error.response.data.message,
            icon: 'error',
            buttonsStyling: false,
            confirmButtonText: 'Ok, got it!',
            heightAuto: false,
            customClass: {
              confirmButton: 'btn btn-sm btn-primary btm-sm py-2'
            }
          })
          console.error("Error submitting form:", error);
          // Optional: show a toast or notification to the user
        });
    };


    onMounted(() => {
      initTabulator()
      reInitOnResizeWindow()
    })

    return {
      formData, pagedata,
      tableRef,
      filter,
      onFilter,
      onResetFilter,
      onExportCsv,
      onExportJson,
      onExportXlsx,
      onExportHtml,
      onPrint,
      submitForm
    }
  }
})
</script>
